module.exports = __webpack_public_path__ + "static/cam-hotel-case-study-03ee19ab43654f2fa904d588e78cf87d.webp";